import { EventEmitter, Injectable } from "@angular/core";

@Injectable({ providedIn: 'root' })
export class Cluster {

    changeClusterEvent = new EventEmitter<number>();
    changeDataEvent = new EventEmitter<any>();
    changeHoverValueEvent = new EventEmitter<number>();

    changeSidebarMessages = new EventEmitter<any>();


    currentFeature!: Object;


    hoverFirstImage: Boolean = false;


    constructor() { }

    keys: string[] = [];
    values: number[] = [];

    hoverValue: number = -1;


    urlArray: string[] = [];
    commentArray: string[] = [];
    cloudyArray: boolean[] = [];
    currentCropName: string = '';

    changeHoverValue(new_value: number) {
        this.hoverValue = new_value;
    }


    // COLORI DA UTILIZZARE PER I
    // SINGOLI CLUSTER
    private colorList: string[] = [
        'rgba(255, 0, 0, 0.4)',
        'rgba(255, 128, 0, 0.4)',
        'rgba(255, 255, 0, 0.4)',
        'rgba(255, 135, 183, 0.4)',
        'rgba(0, 255, 200, 0.4)',
        'rgba(0, 255, 255, 0.4)',
        'rgba(91, 91, 255, 0.4)',
        'rgba(189, 55, 255, 0.4)',
        'rgba(255, 55, 255, 0.4)',
        'rgba(0, 255, 0, 0.4)'
    ]
    currentColor: number = -1;

    getColor(cluster: number) {
        return this.colorList[cluster];
    }

    private clusterSelected: number = -1;
    private messagesList = [
        'Tutte le aree',
        'Doppio avvicendamento colturale',
        'Solo colture estive',
        'Prevalentemente prati - erbai - medicai',
        'Colture miste con debole attività vegetativa',
        'Tutte colture primaverili CAV (Qualche doppio avvicendamento colturale)',
        'Colture miste con qualche doppio avvicendamento colturale',
        'Tutti doppi avvicendamenti colturali',
        'Alta attività vegetativa - no arature o semina su sodo',
        'Principalmente colture estive',
        'Solo colture estive'
    ]

    getMexList() {
        return this.messagesList;
    }

    changeCluster(value: number) {
        this.clusterSelected = value;
    }

    getCluster(): number {
        return this.clusterSelected;
    }

    changeKeysValues(keys: string[], values: number[]) {
        this.values = values;
        this.keys = keys;
    }

    getClusterMexWithoutValue(): string {
        switch (this.clusterSelected) {
            case -1:
                return this.messagesList[0];
            case 0:
                return this.messagesList[1];
            case 1:
                return this.messagesList[2];
            case 2:
                return this.messagesList[3];
            case 3:
                return this.messagesList[4];
            case 4:
                return this.messagesList[5];
            case 5:
                return this.messagesList[6];
            case 6:
                return this.messagesList[7];
            case 7:
                return this.messagesList[8];
            case 8:
                return this.messagesList[9];
            case 9:
                return this.messagesList[10];
        }
        return 'Errore: parametro non incluso nei 9 cluster';
    }

    getClusterMex(value: number): string {
        switch (value) {
            case -1:
                return this.messagesList[0];
            case 0:
                return this.messagesList[1];
            case 1:
                return this.messagesList[2];
            case 2:
                return this.messagesList[3];
            case 3:
                return this.messagesList[4];
            case 4:
                return this.messagesList[5];
            case 5:
                return this.messagesList[6];
            case 6:
                return this.messagesList[7];
            case 7:
                return this.messagesList[8];
            case 8:
                return this.messagesList[9];
            case 9:
                return this.messagesList[10];
        }
        return 'Errore: parametro non incluso nei 9 cluster';
    }
}